import { runtime } from '@do/lobster-roll-cli/runtime';

/**
 * Returns ID information about the currently authenticated user.
 * Should not be called from the login page or any other page where the user is not authenticated.
 *
 * Prefer `useCurrentUserOrNull` if you want to handle unauthenticated users gracefully.
 */
export const useCurrentUser = () => {
  const data = useCurrentUserOrNull();

  if (data === null) {
    const url = new URL('/login', window.location.origin);
    url.searchParams.set('redirect_url', window.location.pathname + window.location.search);

    window.location.assign(url.toString());

    /**
     * While redirecting, suspend indefinitely. Ensures that the unauthenticated state can never be returned.
     */
    throw new Promise(() => {});
  }

  return data;
};

export const useCurrentUserOrNull = () => {
  const { data } = runtime.dataBridge.use('user-context');
  return data.status === 'authenticated' ? data : null;
};
